export default {
    disabled: Boolean
}
